<app-dialog-container
    [loading]="false"
    (closeEvent)="onClose()"
>
    <div class="is-flex align-center justify-center break-newline has-text-centered">{{ data.text }}</div>
    <br />
    <div class="level is-full-width">
        <app-button
            *ngIf="data.showCancel"
            [class]="'level-item'"
            [buttonText]="data.cancelText"
            (buttonClick)="onCancel()"
            [type]="'stroked'"
        />
        <app-button
            [class]="'level-item'"
            [buttonText]="data.confirmText"
            (buttonClick)="onConfirm()"
            [type]="'flat'"
        />
        <app-button
            [class]="'level-item'"
            [buttonText]="data.denyText"
            (buttonClick)="onDeny()"
            [type]="'flat'"
            [color]="'danger'"
        />
    </div>
</app-dialog-container>
